/** @jsxImportSource @emotion/react */
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmarkCircle } from '@fortawesome/free-regular-svg-icons';
import { hooks as commonHooks } from '@sitebuilder/common';
import { searchGreySvg } from '../assets/images';
import { actionCreators } from '../reducers/templateEditor';
import { StateShape as ReduxStateShape } from '../reducers';

const AnnotationPickerLayer = () => {
    const { annotations } = commonHooks.useAppContext();
    const [resourcesSearch, setResourcesSearch] = useState('');
    const { selectedAnnotationPickerValue } = useSelector((state: ReduxStateShape) => ({
        ...state.templateEditor,
    }));
    const [_annotations, setAnnotations] = useState(annotations?.items);
    const [selectedAnnotationType, setSelectdAnnotationType] = useState('annotation');
    const i18n = commonHooks.useLocalization();
    const dispatch = useDispatch();

    const annotationTypes = [
        { id: 'annotation', text: i18n.t('annotation_type_id') },
        { id: 'markerTarget', text: i18n.t('annotation_type_marker') },
    ];

    const onClickRow = (r: string) => {
        const value =
            selectedAnnotationType === 'annotation'
                ? `{{{ byId '${r}' }}}`
                : `{{{ byMarkerTargetId '${r}' }}}`;

        dispatch(actionCreators.setSelectedAnnotationPickerValue(value));
    };

    const onClickClose = () => {
        dispatch(actionCreators.setIsShowAnnotationPicker(false));
        selectedAnnotationPickerValue?.length &&
            dispatch(actionCreators.setSelectedAnnotationPickerValue(null));
    };

    const onSelectAnnoationType = (e: any) => {
        setSelectdAnnotationType(e.target.value);
        handleChange({ target: { value: '' } });
    };

    // Handles search functioanlity for widgets
    const handleChange = (e: any) => {
        setResourcesSearch(e.target.value);
        const annotationNodes = document.querySelectorAll<HTMLElement>(
            '.annotation-picker-layer .annotation'
        );
        Array.from(annotationNodes).forEach((node: any) => {
            if (
                node.textContent!.toLowerCase().indexOf(e.target.value.toLowerCase()) >= 0 ||
                !e.target.value.trim().length
            ) {
                node.style.display = 'block';
            } else {
                node.style.display = 'none';
            }
        });
    };

    useEffect(() => {
        if (selectedAnnotationType === 'markerTarget') {
            const markerTargetAnnotations =
                annotations?.items?.length &&
                annotations.items.reduce((arr: any, item) => {
                    let index;

                    const filteredArray = arr.filter((a: any, i: number) => {
                        if (a.markerTargetId === item.markerTargetId) {
                            index = i;
                            return true;
                        }

                        return false;
                    });

                    if (filteredArray.length) {
                        if (typeof index === 'number') {
                            arr[index].text = `${arr[index].text}<p>${item.text}</p>`;
                        }
                    } else {
                        arr.push({ ...item });
                    }

                    return arr;
                }, []);
            setAnnotations(markerTargetAnnotations);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedAnnotationType]);

    return (
        <div className="annotation-picker-layer">
            <div className="header">
                <h3 className="title">{i18n.t('annotations')}</h3>
                <button className="close-button" onClick={onClickClose}>
                    <FontAwesomeIcon icon={faXmarkCircle} />
                </button>
            </div>
            {_annotations?.length ? (
                <div className="annotations-container">
                    <div className="input-search-annotation">
                        <img src={searchGreySvg} alt="Search icon" />
                        <input
                            type="text"
                            placeholder={i18n.t('all_annotations')}
                            value={resourcesSearch}
                            onChange={handleChange}
                            className={'input-textfield'}
                        />
                    </div>
                    <div className="annotation-types">
                        {annotationTypes.map((a, i) => (
                            <div key={`${a.id}-${i}`}>
                                <input
                                    type="radio"
                                    id={a.id}
                                    value={a.id}
                                    name="annotations"
                                    onChange={onSelectAnnoationType}
                                    defaultChecked={i === 0}
                                />
                                <label htmlFor={a.id}>{a.text}</label>
                            </div>
                        ))}
                    </div>
                    <div className="annotations-list">
                        {_annotations.map((ann: any, i) => (
                            <div
                                className={'annotation'}
                                key={`${ann.id}-${i}`}
                                onClick={() =>
                                    onClickRow(
                                        selectedAnnotationType === 'annotation'
                                            ? ann.id
                                            : ann.markerTargetId
                                    )
                                }
                            >
                                <p className={'annotation-key'}>
                                    {selectedAnnotationType === 'annotation'
                                        ? ann.id
                                        : ann.markerTargetId}
                                </p>
                                <p
                                    className="annotation-value"
                                    dangerouslySetInnerHTML={{
                                        __html: i18n.format(ann.text as string),
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div>{i18n.t('annotations_not_available')}</div>
            )}
        </div>
    );
};

export default AnnotationPickerLayer;
